import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 1.5rem 1rem calc(1rem + env(safe-area-inset-bottom)) 1rem;
  background: ${({ theme }) => theme.token('background-pattern')};
`;
